import * as types from "./mutation-types";
import router from "@/plugins/router";

export const loading = ({ commit }) => {
  commit(types.LOADING);
};

export const loaded = ({ commit }) => {
  commit(types.LOADED);
};

export const login = ({ commit }, token) => {
  localStorage.setItem("token", token);
  commit(types.LOGIN);
  router.push({ path: "/" });
};

export const logout =({commit})=>{
  localStorage.removeItem("token");
  commit(types.LOGOUT);
  router.push({path:"/login"});
}

export const toggleDark = ({commit}) =>{
  commit(types.TOGGLEDARK);
}